import {ACCESS_RIGHTS} from 'src/hooks/access-rights';

import {PermissionLevels} from './typedef';

import type {PermissionTree, PermissionTreeItem} from './typedef';
import type {TreeData} from '@pb/kit-component-tree-list';


export const PERMISSION_LEVELS = [4, 3, 2, 1, 0];

const RESTRICTED_PERMISSION = {
    level: PermissionLevels.Restricted,
    children: [],
};

const ADMIN_V2_ACCESS: PermissionTreeItem = {
    code: ACCESS_RIGHTS.PB_ADMIN_2_ACCESS,
    level: PermissionLevels.View,
    children: [RESTRICTED_PERMISSION],
};

const WEBSITE_ADMIN_ACCESS: PermissionTreeItem = {
    code: ACCESS_RIGHTS.WEBSITE_ADMIN_ACCESS,
    level: PermissionLevels.View,
    children: [RESTRICTED_PERMISSION],
};


const MOBILE_ADMIN_ACCESS: PermissionTreeItem = {
    code: ACCESS_RIGHTS.MOBILE_ADMIN,
    level: PermissionLevels.View,
    children: [RESTRICTED_PERMISSION],
};

const GDPR_TOOL_ACCESS: PermissionTreeItem = {
    code: ACCESS_RIGHTS.GDPR_TOOL_USER,
    level: PermissionLevels.View,
    children: [RESTRICTED_PERMISSION],
};

const LOGIN_AS_ACCESS: PermissionTreeItem = {
    code: ACCESS_RIGHTS.LOGIN_AS,
    level: PermissionLevels.Edit,
    children: [RESTRICTED_PERMISSION],
};


const USER_MFA_MANAGEMENT_ACCESS: PermissionTreeItem = {
    code: ACCESS_RIGHTS.USER_MFA_MANAGEMENT,
    level: PermissionLevels.Edit,
    children: [RESTRICTED_PERMISSION],
};

const USER_CONTENT_VIEW: PermissionTreeItem = {
    code: ACCESS_RIGHTS.USER_CONTENT_VIEW,
    level: PermissionLevels.View,
    children: [RESTRICTED_PERMISSION],
};

const CUSTOMER_PII_TREE: PermissionTreeItem = {
    code: ACCESS_RIGHTS.PII_EDITABLE,
    level: PermissionLevels.Edit,
    children: [
        {
            code: ACCESS_RIGHTS.PII_VIEWABLE,
            level: PermissionLevels.View,
            children: [RESTRICTED_PERMISSION],
        },
    ],
};

export const ACCOUNT_PERMISSION_TREE: PermissionTreeItem = {
    code: ACCESS_RIGHTS.ACCOUNT_SCREEN_DELETE,
    level: PermissionLevels.Delete,
    children: [
        {
            code: ACCESS_RIGHTS.ACCOUNT_SCREEN_CREATE,
            level: PermissionLevels.Create,
            children: [
                {
                    code: ACCESS_RIGHTS.ACCOUNT_SCREEN_EDIT,
                    level: PermissionLevels.Edit,
                    children: [
                        {
                            code: ACCESS_RIGHTS.ACCOUNT_SCREEN_VIEW,
                            level: PermissionLevels.View,
                            children: [RESTRICTED_PERMISSION],
                        },
                    ],
                },
            ],
        },
    ],
};

const ALL_LICENSE_TYPES_ACCESS: PermissionTreeItem = {
    code: ACCESS_RIGHTS.ALL_LICENSE_TYPES_ACCESS,
    level: PermissionLevels.Edit,
    children: [RESTRICTED_PERMISSION],
};

const GLOBAL_ACCOUNT_MANAGEMENT_ACCESS: PermissionTreeItem = {
    code: ACCESS_RIGHTS.GLOBAL_ACCOUNT_MANAGEMENT,
    level: PermissionLevels.Edit,
    children: [RESTRICTED_PERMISSION],
};


const CHANGE_USER_ACCOUNT_ACCESS: PermissionTreeItem = {
    code: ACCESS_RIGHTS.CHANGE_USER_ACCOUNT,
    level: PermissionLevels.Edit,
    children: [RESTRICTED_PERMISSION],
};

export const CONFERENCE_PERMISSION_TREE: PermissionTreeItem = {
    code: ACCESS_RIGHTS.CONFERENCE_SETUP,
    level: PermissionLevels.Create,
    children: [
        {
            code: ACCESS_RIGHTS.CONFERENCE_EDIT,
            level: PermissionLevels.Edit,
            children: [
                {
                    code: ACCESS_RIGHTS.CONFERENCE_VIEW,
                    level: PermissionLevels.View,
                    children: [RESTRICTED_PERMISSION],
                },
            ],
        },
    ],
};

export const ACCOUNT_LIMITS_PERMISSION_TREE: PermissionTreeItem = {
    code: ACCESS_RIGHTS.ACCOUNT_LIMITS_EDIT,
    level: PermissionLevels.Edit,
    children: [
        {
            code: ACCESS_RIGHTS.ACCOUNT_LIMITS_VIEW,
            level: PermissionLevels.View,
            children: [RESTRICTED_PERMISSION],
        },
    ],
};

export const ACCOUNT_ENTITLEMENTS_PERMISSION_TREE: PermissionTreeItem = {
    code: ACCESS_RIGHTS.ACCOUNT_ENTITLEMENTS_EDIT,
    level: PermissionLevels.Edit,
    children: [
        {
            code: ACCESS_RIGHTS.ACCOUNT_ENTITLEMENTS_VIEW,
            level: PermissionLevels.View,
            children: [RESTRICTED_PERMISSION],
        },
    ],
};

export const USER_PERMISSION_TREE: PermissionTreeItem = {
    code: ACCESS_RIGHTS.USER_SCREEN_DELETE,
    level: PermissionLevels.Delete,
    children: [
        {
            code: ACCESS_RIGHTS.USER_SCREEN_CREATE,
            level: PermissionLevels.Create,
            children: [
                {
                    code: ACCESS_RIGHTS.USER_SCREEN_EDIT,
                    level: PermissionLevels.Edit,
                    children: [
                        {
                            code: ACCESS_RIGHTS.USER_SCREEN_VIEW,
                            level: PermissionLevels.View,
                            children: [RESTRICTED_PERMISSION],
                        },
                    ],
                },
            ],
        },
    ],
};

export const USER_LIMITS_PERMISSION_TREE: PermissionTreeItem = {
    code: ACCESS_RIGHTS.USER_LIMITS_EDIT,
    level: PermissionLevels.Edit,
    children: [
        {
            code: ACCESS_RIGHTS.USER_LIMITS_VIEW,
            level: PermissionLevels.View,
            children: [RESTRICTED_PERMISSION],
        },
    ],
};

export const USER_ENTITLEMENTS_PERMISSION_TREE: PermissionTreeItem = {
    code: ACCESS_RIGHTS.USER_ENTITLEMENTS_EDIT,
    level: PermissionLevels.Edit,
    children: [
        {
            code: ACCESS_RIGHTS.USER_ENTITLEMENTS_VIEW,
            level: PermissionLevels.View,
            children: [RESTRICTED_PERMISSION],
        },
    ],
};

export const GROUP_PERMISSION_TREE: PermissionTreeItem = {
    code: ACCESS_RIGHTS.GROUP_SCREEN_DELETE,
    level: PermissionLevels.Delete,
    children: [
        {
            code: ACCESS_RIGHTS.GROUP_SCREEN_CREATE,
            level: PermissionLevels.Create,
            children: [
                {
                    code: ACCESS_RIGHTS.GROUP_SCREEN_EDIT,
                    level: PermissionLevels.Edit,
                    children: [
                        {
                            code: ACCESS_RIGHTS.GROUP_SCREEN_VIEW,
                            level: PermissionLevels.View,
                            children: [RESTRICTED_PERMISSION],
                        },
                    ],
                },
            ],
        },
    ],
};

export const LICENSE_PERMISSION_TREE: PermissionTreeItem = {
    code: ACCESS_RIGHTS.LICENSE_SCREEN_CREATE,
    level: PermissionLevels.Create,
    children: [
        {
            code: ACCESS_RIGHTS.LICENSE_SCREEN_EDIT,
            level: PermissionLevels.Edit,
            children: [
                {
                    code: ACCESS_RIGHTS.LICENSE_SCREEN_VIEW,
                    level: PermissionLevels.View,
                    children: [RESTRICTED_PERMISSION],
                },
            ],
        },
    ],
};

export const API_V2_PERMISSION_TREE: PermissionTreeItem = {
    code: ACCESS_RIGHTS.API_V2_SCREEN_EDIT,
    level: PermissionLevels.Edit,
    children: [
        {
            code: ACCESS_RIGHTS.API_V2_SCREEN_VIEW,
            level: PermissionLevels.View,
            children: [RESTRICTED_PERMISSION],
        },
    ],
};

export const SSO_PERMISSION_TREE: PermissionTreeItem = {
    code: ACCESS_RIGHTS.SSO_SCREEN_EDIT,
    level: PermissionLevels.Edit,
    children: [
        {
            code: ACCESS_RIGHTS.SSO_SCREEN_VIEW,
            level: PermissionLevels.View,
            children: [RESTRICTED_PERMISSION],
        },
    ],
};

export const MICROSITES_PERMISSION_TREE: PermissionTreeItem = {
    code: ACCESS_RIGHTS.MICROSITES_SCREEN_EDIT,
    level: PermissionLevels.Edit,
    children: [
        {
            code: ACCESS_RIGHTS.MICROSITES_SCREEN_VIEW,
            level: PermissionLevels.View,
            children: [RESTRICTED_PERMISSION],
        },
    ],
};

export const ACCOUNT_DD_MCP_PERMISSION_TREE: PermissionTreeItem = {
    code: ACCESS_RIGHTS.ACCOUNT_DD_MCP_EDIT,
    level: PermissionLevels.Edit,
    children: [
        {
            code: ACCESS_RIGHTS.ACCOUNT_DD_MCP_VIEW,
            level: PermissionLevels.View,
            children: [RESTRICTED_PERMISSION],
        },
    ],
};

export const ACCOUNT_CONNECTOR_LIMITS_PERMISSION_TREE: PermissionTreeItem = {
    code: ACCESS_RIGHTS.ACCOUNT_CONNECTOR_LIMITS_EDIT,
    level: PermissionLevels.Edit,
    children: [
        {
            code: ACCESS_RIGHTS.ACCOUNT_CONNECTOR_LIMITS_VIEW,
            level: PermissionLevels.View,
            children: [RESTRICTED_PERMISSION],
        },
    ],
};

export const USER_CONNECTOR_LIMITS_PERMISSION_TREE: PermissionTreeItem = {
    code: ACCESS_RIGHTS.USER_CONNECTOR_LIMITS_EDIT,
    level: PermissionLevels.Edit,
    children: [
        {
            code: ACCESS_RIGHTS.USER_CONNECTOR_LIMITS_VIEW,
            level: PermissionLevels.View,
            children: [RESTRICTED_PERMISSION],
        },
    ],
};

export const CRM_PERMISSION_TREE: PermissionTreeItem = {
    code: ACCESS_RIGHTS.CRM_SCREEN_EDIT,
    level: PermissionLevels.Edit,
    children: [
        {
            code: ACCESS_RIGHTS.CRM_SCREEN_VIEW,
            level: PermissionLevels.View,
            children: [RESTRICTED_PERMISSION],
        },
    ],
};

export const BULK_UPDATE_USER_CRM_ACCESS: PermissionTreeItem = {
    code: ACCESS_RIGHTS.BULK_UPDATE_USER_CRM,
    level: PermissionLevels.Edit,
    children: [RESTRICTED_PERMISSION],
};

export const BULK_ADD_USER_ACCESS: PermissionTreeItem = {
    code: ACCESS_RIGHTS.BULK_USER_IMPORT,
    level: PermissionLevels.Edit,
    children: [RESTRICTED_PERMISSION],
};

export const BULK_ADD_ACCOUNT_TEAM_MEMBERS_ACCESS: PermissionTreeItem = {
    code: ACCESS_RIGHTS.BULK_ACCOUNT_TEAM_MEMBER,
    level: PermissionLevels.Edit,
    children: [RESTRICTED_PERMISSION],
};

export const BULK_REMOVE_ACCOUNT_TEAM_MEMBERS_ACCESS: PermissionTreeItem = {
    code: ACCESS_RIGHTS.BULK_REMOVE_ACCOUNT_TEAM_MEMBERS,
    level: PermissionLevels.Edit,
    children: [RESTRICTED_PERMISSION],
};

export const BULK_UPDATE_ACCOUNT_STATUS_ACCESS: PermissionTreeItem = {
    code: ACCESS_RIGHTS.BULK_ACCOUNT_STATUS_UPDATE,
    level: PermissionLevels.Edit,
    children: [RESTRICTED_PERMISSION],
};

export const BULK_USER_STATE_UPDATE: PermissionTreeItem = {
    code: ACCESS_RIGHTS.BULK_USER_STATE_UPDATE,
    level: PermissionLevels.Edit,
    children: [RESTRICTED_PERMISSION],
};

export const BULK_SET_ACCOUNT_GROUP_ACCESS: PermissionTreeItem = {
    code: ACCESS_RIGHTS.BULK_ACCOUNT_GROUP_UPDATE,
    level: PermissionLevels.Edit,
    children: [RESTRICTED_PERMISSION],
};

export const BULK_SET_NEWSLETTER_ACCESS: PermissionTreeItem = {
    code: ACCESS_RIGHTS.BULK_NEWSLETTER_SUBSCRIPTION_UPDATE,
    level: PermissionLevels.Edit,
    children: [RESTRICTED_PERMISSION],
};

export const BULK_USER_ACCOUNT_CHANGE_ACCESS: PermissionTreeItem = {
    code: ACCESS_RIGHTS.BULK_USER_ACCOUNT_CHANGE,
    level: PermissionLevels.Edit,
    children: [RESTRICTED_PERMISSION],
};

export const BULK_LICENSE_UPDATE_ACCESS: PermissionTreeItem = {
    code: ACCESS_RIGHTS.BULK_LICENSE_UPDATE,
    level: PermissionLevels.Edit,
    children: [RESTRICTED_PERMISSION],
};

export const BULK_PRODUCTS_UPDATE_ACCESS: PermissionTreeItem = {
    code: ACCESS_RIGHTS.BULK_PRODUCTS_UPDATE,
    level: PermissionLevels.Edit,
    children: [RESTRICTED_PERMISSION],
};

export const BULK_MFA_SETTINGS_UPDATE: PermissionTreeItem = {
    code: ACCESS_RIGHTS.BULK_MFA_SETTINGS_UPDATE,
    level: PermissionLevels.Edit,
    children: [RESTRICTED_PERMISSION],
};

export const BULK_UPDATE_DEVICE_REGISTRATION: PermissionTreeItem = {
    code: ACCESS_RIGHTS.BULK_UPDATE_DEVICE_REGISTRATION,
    level: PermissionLevels.Edit,
    children: [RESTRICTED_PERMISSION],
};

export const BULK_UPDATE_LCD_SUBSCRIPTION: PermissionTreeItem = {
    code: ACCESS_RIGHTS.LCD_CREDIT_ANALYSIS_BULK_UPDATE,
    level: PermissionLevels.Edit,
    children: [RESTRICTED_PERMISSION],
};

export const BULK_EXPORT_ENTITLEMENTS: PermissionTreeItem = {
    code: ACCESS_RIGHTS.EXPORT_ENTITLEMENTS,
    level: PermissionLevels.Edit,
    children: [RESTRICTED_PERMISSION],
};

export const BULK_IMPORT_ENTITLEMENTS: PermissionTreeItem = {
    code: ACCESS_RIGHTS.IMPORT_ENTITLEMENTS,
    level: PermissionLevels.Edit,
    children: [RESTRICTED_PERMISSION],
};

export const LOGIN_LINK_GENERATOR_ACCESS: PermissionTreeItem = {
    code: ACCESS_RIGHTS.BULK_LOGIN_LINK_GENERATOR,
    level: PermissionLevels.Edit,
    children: [RESTRICTED_PERMISSION],
};

export const ROLES_PERMISSIONS_MANAGEMENT_ACCESS: PermissionTreeItem = {
    code: ACCESS_RIGHTS.MANAGE_PERMISSIONS_FOR_A_PROFILE,
    level: PermissionLevels.Edit,
    children: [RESTRICTED_PERMISSION],
};

export const ANALYST_COMMENTARY_DEALS_ACCESS: PermissionTreeItem = {
    code: ACCESS_RIGHTS.ANALYST_COMMENTARY_DEALS,
    level: PermissionLevels.Edit,
    children: [RESTRICTED_PERMISSION],
};

export const CREATE_MARKET_MAP_VERTICALS_ACCESS: PermissionTreeItem = {
    code: ACCESS_RIGHTS.CREATE_MARKET_MAP_VERTICALS,
    level: PermissionLevels.Edit,
    children: [RESTRICTED_PERMISSION],
};

export const PUBLISH_WORKSPACES_ACCESS: PermissionTreeItem = {
    code: ACCESS_RIGHTS.PUBLISH_WORKSPACES,
    level: PermissionLevels.Edit,
    children: [RESTRICTED_PERMISSION],
};

export const MANAGE_SYSTEM_ACCOUNTS_ACCESS: PermissionTreeItem = {
    code: ACCESS_RIGHTS.MANAGE_SYSTEM_ACCOUNTS,
    level: PermissionLevels.Edit,
    children: [RESTRICTED_PERMISSION],
};

export const MANAGE_ENTITLEMENTS_ACCESS: PermissionTreeItem = {
    code: ACCESS_RIGHTS.DELETE_ENTITLEMENTS,
    level: PermissionLevels.Delete,
    children: [
        {
            code: ACCESS_RIGHTS.MANAGE_ENTITLEMENTS,
            level: PermissionLevels.Edit,
            children: [RESTRICTED_PERMISSION],
        },
    ],
};

export const MANAGE_ENTITLEMENT_PRESETS_ACCESS: PermissionTreeItem = {
    code: ACCESS_RIGHTS.DELETE_ENTITLEMENT_PRESET,
    level: PermissionLevels.Delete,
    children: [
        {
            code: ACCESS_RIGHTS.MANAGE_ENTITLEMENT_PRESET,
            level: PermissionLevels.Edit,
            children: [RESTRICTED_PERMISSION],
        },
    ],
};

export const LIVE_AGENT_CONFIGURATOR_ACCESS: PermissionTreeItem = {
    code: ACCESS_RIGHTS.LIVE_AGENT_CONFIGURATOR,
    level: PermissionLevels.Edit,
    children: [RESTRICTED_PERMISSION],
};


export const PLATFORM_ALERT_BUILDER_ACCESS: PermissionTreeItem = {
    code: ACCESS_RIGHTS.PLATFORM_ALERT_BUILDER,
    level: PermissionLevels.Edit,
    children: [RESTRICTED_PERMISSION],
};

export const INTERNAL_NOTIFICATION_BUILDER_ACCESS: PermissionTreeItem = {
    code: ACCESS_RIGHTS.INTERNAL_NOTIFICATION_BUILDER,
    level: PermissionLevels.Edit,
    children: [RESTRICTED_PERMISSION],
};

export const FULL_STORY_CONFIGURATOR_ACCESS: PermissionTreeItem = {
    code: ACCESS_RIGHTS.FULL_STORY_CONFIGURATOR,
    level: PermissionLevels.Edit,
    children: [RESTRICTED_PERMISSION],
};

export const SSO_ACCOUNT_STATISTICS_ACCESS: PermissionTreeItem = {
    code: ACCESS_RIGHTS.SSO_ACCOUNT_STATISTICS,
    level: PermissionLevels.Edit,
    children: [RESTRICTED_PERMISSION],
};

export const MANAGE_SYSTEM_PROPERTIES_ACCESS: PermissionTreeItem = {
    code: ACCESS_RIGHTS.MANAGE_SYSTEM_PROPERTIES,
    level: PermissionLevels.Edit,
    children: [RESTRICTED_PERMISSION],
};

export const TEMPORARY_RESTRICTION_CHINA_ACCESS: PermissionTreeItem = {
    code: ACCESS_RIGHTS.TEMPORARY_RESTRICTION_CHINA,
    level: PermissionLevels.Edit,
    children: [RESTRICTED_PERMISSION],
};

export const ACCOUNT_REPORT_SCREEN_VIEW_ACCESS: PermissionTreeItem = {
    code: ACCESS_RIGHTS.ACCOUNT_REPORTS_SCREEN_VIEW,
    level: PermissionLevels.View,
    children: [RESTRICTED_PERMISSION],
};

export const USER_PRODUCTS_PERMISSION_TREE: PermissionTreeItem = {
    code: ACCESS_RIGHTS.USER_PRODUCTS_EDIT,
    level: PermissionLevels.Edit,
    children: [{
        code: ACCESS_RIGHTS.USER_PRODUCTS_VIEW,
        level: PermissionLevels.View,
        children: [RESTRICTED_PERMISSION],
    }],
};

export const ACCOUNT_PRODUCTS_PERMISSION_TREE: PermissionTreeItem = {
    code: ACCESS_RIGHTS.ACCOUNT_PRODUCTS_CREATE,
    level: PermissionLevels.Create,
    children: [
        {
            code: ACCESS_RIGHTS.ACCOUNT_PRODUCTS_EDIT,
            level: PermissionLevels.Edit,
            children: [
                {
                    code: ACCESS_RIGHTS.ACCOUNT_PRODUCTS_VIEW,
                    level: PermissionLevels.View,
                    children: [RESTRICTED_PERMISSION],
                },
            ],
        },
    ],
};

export const PERMISSIONS_TREE_DATA: TreeData<PermissionTree>[] = [
    {
        id: 'website-admin-access',
        expanded: true,
        data: {module: 'Other Applications', tree: null},
        children: [
            {
                id: 'website-admin-access',
                expanded: false,
                data: {module: 'PB Website Admin Access', tree: WEBSITE_ADMIN_ACCESS},
                children: [],
            },
            {
                id: 'gdpr-tool-access',
                expanded: false,
                data: {module: 'GDPR Tool Access', tree: GDPR_TOOL_ACCESS},
                children: [],
            },
            {
                id: 'mobile-admin-access',
                expanded: false,
                data: {module: 'Mobile Admin Access', tree: MOBILE_ADMIN_ACCESS},
                children: [],
            },
        ],
    },
    {
        id: 'pitchbook-admin',
        expanded: true,
        data: {module: 'PitchBook Admin', tree: null},
        children: [
            {
                id: 'pb-admin-2.0-access',
                expanded: false,
                data: {module: 'PB Admin 2.0 Access', tree: ADMIN_V2_ACCESS},
                children: [],
            },
            {
                id: 'users-pii',
                expanded: false,
                data: {module: 'Customer PII', tree: CUSTOMER_PII_TREE},
                children: [],
            },
            {
                id: 'global-account-management-access',
                expanded: false,
                data: {
                    module: 'Global Account Management',
                    tree: GLOBAL_ACCOUNT_MANAGEMENT_ACCESS,
                    explanation:
                        'This permission allows the editing of accounts and users even if the admin\n' +
                        'is not assigned to the account as the account team member',
                },
                children: [],
            },
            {
                id: 'users-access',
                expanded: true,
                data: {module: 'Users', tree: null},
                children: [
                    {
                        id: 'users-access',
                        expanded: false,
                        data: {module: 'User Information', tree: USER_PERMISSION_TREE},
                        children: [],
                    },
                    {
                        id: 'change-user-account-access',
                        expanded: false,
                        data: {module: 'Change User\'s Account', tree: CHANGE_USER_ACCOUNT_ACCESS},
                        children: [],
                    },
                    {
                        id: 'user-limits-access',
                        expanded: false,
                        data: {module: 'User Limits', tree: USER_LIMITS_PERMISSION_TREE},
                        children: [],
                    },
                    {
                        id: 'user-connector-limits-access',
                        expanded: false,
                        data: {module: 'User Connector Limits', tree: USER_CONNECTOR_LIMITS_PERMISSION_TREE},
                        children: [],
                    },
                    {
                        id: 'user-entitlements-access',
                        expanded: false,
                        data: {module: 'User Entitlements', tree: USER_ENTITLEMENTS_PERMISSION_TREE},
                        children: [],
                    },
                    {
                        id: 'user-products-access',
                        expanded: false,
                        data: {module: 'User Products', tree: USER_PRODUCTS_PERMISSION_TREE},
                        children: [],
                    },
                    {
                        id: 'login-as-access',
                        expanded: false,
                        data: {module: 'Login As', tree: LOGIN_AS_ACCESS},
                        children: [],
                    },
                    {
                        id: 'user-mfa-management-access',
                        expanded: false,
                        data: {module: 'User MFA Management', tree: USER_MFA_MANAGEMENT_ACCESS},
                        children: [],
                    },
                    {
                        id: 'user-content-view-access',
                        expanded: false,
                        data: {module: 'User Content', tree: USER_CONTENT_VIEW},
                        children: [],
                    },
                ],
            },
            {
                id: 'account-management',
                expanded: true,
                data: {module: 'Accounts', tree: null},
                children: [
                    {
                        id: 'accounts-access',
                        expanded: false,
                        data: {module: 'Account Information', tree: ACCOUNT_PERMISSION_TREE},
                        children: [],
                    },
                    {
                        id: 'all-licenses-access',
                        expanded: false,
                        data: {
                            module: 'All License Types Access',
                            tree: ALL_LICENSE_TYPES_ACCESS,
                            explanation:
                                'This permission allows the editing of licenses of all types.\n' +
                                'If restricted:\n' +
                                '-  Creation/editing of the other license types except for Trial and\n' +
                                '   Research Center Trial is not allowed.\n' +
                                '-  The admin will only be able to create new users (single creation or bulk) if\n' +
                                '   the account license is active and the license type is Trial or Research Сenter\n' +
                                '   Trial and the required user creation permissions are enabled.',
                        },
                        children: [],
                    },
                    {
                        id: 'licenses-access',
                        expanded: false,
                        data: {module: 'Account Licenses', tree: LICENSE_PERMISSION_TREE},
                        children: [],
                    },
                    {
                        id: 'account-limits-access',
                        expanded: false,
                        data: {module: 'Account Limits', tree: ACCOUNT_LIMITS_PERMISSION_TREE},
                        children: [],
                    },
                    {
                        id: 'account-connector-limits-access',
                        expanded: false,
                        data: {module: 'Account Connector Limits', tree: ACCOUNT_CONNECTOR_LIMITS_PERMISSION_TREE},
                        children: [],
                    },
                    {
                        id: 'account-entitlements-access',
                        expanded: false,
                        data: {module: 'Account Entitlements', tree: ACCOUNT_ENTITLEMENTS_PERMISSION_TREE},
                        children: [],
                    },
                    {
                        id: 'account-products-access',
                        expanded: false,
                        data: {module: 'Account Products', tree: ACCOUNT_PRODUCTS_PERMISSION_TREE},
                        children: [],
                    },
                    {
                        id: 'groups-access',
                        expanded: false,
                        data: {module: 'Account Groups', tree: GROUP_PERMISSION_TREE},
                        children: [],
                    }, {
                        id: 'crm-access',
                        expanded: false,
                        data: {module: 'Account CRM Configurations', tree: CRM_PERMISSION_TREE},
                        children: [],
                    }, {
                        id: 'api-v2-access',
                        expanded: false,
                        data: {module: 'Account API v2', tree: API_V2_PERMISSION_TREE},
                        children: [],
                    }, {
                        id: 'sso-access',
                        expanded: false,
                        data: {module: 'Account SSO', tree: SSO_PERMISSION_TREE},
                        children: [],
                    }, {
                        id: 'microsites-access',
                        expanded: false,
                        data: {module: 'Account Microsite Configurations', tree: MICROSITES_PERMISSION_TREE},
                        children: [],
                    }, {
                        id: 'account-mcp-access',
                        expanded: false,
                        data: {module: 'Account DD MCP Configuration', tree: ACCOUNT_DD_MCP_PERMISSION_TREE},
                        children: [],
                    },
                    {
                        id: 'account-reports-access',
                        expanded: false,
                        data: {module: 'Account Reports', tree: ACCOUNT_REPORT_SCREEN_VIEW_ACCESS},
                        children: [],
                    },
                ],
            },
            {
                id: 'conference-management',
                expanded: true,
                data: {module: 'Conferences', tree: null},
                children: [
                    {
                        id: 'accounts-access',
                        expanded: false,
                        data: {module: 'Conference Information', tree: CONFERENCE_PERMISSION_TREE},
                        children: [],
                    },
                ],
            },
            {
                id: 'bulk-updates-access',
                expanded: true,
                data: {module: 'Bulk Updates', tree: null},
                children: [
                    {
                        id: 'add-users-access',
                        expanded: false,
                        data: {module: 'Add Users', tree: BULK_ADD_USER_ACCESS},
                        children: [],
                    },
                    {
                        id: 'update-user-crm-ids-access',
                        expanded: false,
                        data: {module: 'Update User CRM IDs', tree: BULK_UPDATE_USER_CRM_ACCESS},
                        children: [],
                    },
                    {
                        id: 'add-to-account-team-access',
                        expanded: false,
                        data: {module: 'Add to Account Team', tree: BULK_ADD_ACCOUNT_TEAM_MEMBERS_ACCESS},
                        children: [],
                    },
                    {
                        id: 'remove-from-account-team-access',
                        expanded: false,
                        data: {module: 'Remove from Account Team', tree: BULK_REMOVE_ACCOUNT_TEAM_MEMBERS_ACCESS},
                        children: [],
                    },
                    {
                        id: 'set-account-status-access',
                        expanded: false,
                        data: {module: 'Set Account Status', tree: BULK_UPDATE_ACCOUNT_STATUS_ACCESS},
                        children: [],
                    },
                    {
                        id: 'set-user-state-access',
                        expanded: false,
                        data: {module: 'Set User State', tree: BULK_USER_STATE_UPDATE},
                        children: [],
                    },
                    {
                        id: 'set-account-group-access',
                        expanded: false,
                        data: {module: 'Set Account Group', tree: BULK_SET_ACCOUNT_GROUP_ACCESS},
                        children: [],
                    },
                    {
                        id: 'set-newsletter-subscription-access',
                        expanded: false,
                        data: {module: 'Set Newsletter Subscription', tree: BULK_SET_NEWSLETTER_ACCESS},
                        children: [],
                    },
                    {
                        id: 'change-users-account',
                        expanded: false,
                        data: {module: 'User Account Change', tree: BULK_USER_ACCOUNT_CHANGE_ACCESS},
                        children: [],
                    },
                    {
                        id: 'bulk-license-update-access',
                        expanded: false,
                        data: {module: 'Update License', tree: BULK_LICENSE_UPDATE_ACCESS},
                        children: [],
                    },
                    {
                        id: 'bulk-products-update-access',
                        expanded: false,
                        data: {module: 'Update Products', tree: BULK_PRODUCTS_UPDATE_ACCESS},
                        children: [],
                    },
                    {
                        id: 'bulk-update-device-registration-access',
                        expanded: false,
                        data: {module: 'Update Device Registration', tree: BULK_UPDATE_DEVICE_REGISTRATION},
                        children: [],
                    },
                    {
                        id: 'bulk-update-user-mfa-settings-access',
                        expanded: false,
                        data: {module: 'Update User MFA Settings', tree: BULK_MFA_SETTINGS_UPDATE},
                        children: [],
                    },
                    {
                        id: 'bulk-update-lcd-subscription-access',
                        expanded: false,
                        data: {module: 'Update LCD Credit Analysis Subscription', tree: BULK_UPDATE_LCD_SUBSCRIPTION},
                        children: [],
                    },
                    {
                        id: 'bulk-export-entitlements-access',
                        expanded: false,
                        data: {module: 'Export Entitlements', tree: BULK_EXPORT_ENTITLEMENTS},
                        children: [],
                    },
                    {id: 'bulk-import-entitlements-access',
                        expanded: false,
                        data: {module: 'Import Entitlements', tree: BULK_IMPORT_ENTITLEMENTS},
                        children: [],
                    },
                ],
            },
            {
                id: 'manage-system-accounts-access',
                expanded: false,
                data: {module: 'Manage System Accounts', tree: MANAGE_SYSTEM_ACCOUNTS_ACCESS},
                children: [],
            },
            {
                id: 'manage-system-properties-access',
                expanded: false,
                data: {module: 'Manage System Properties', tree: MANAGE_SYSTEM_PROPERTIES_ACCESS},
                children: [],
            },
            {
                id: 'manage-temporary-restriction-for-china-access',
                expanded: false,
                data: {
                    module: 'Temporary Restrictions for China',
                    tree: TEMPORARY_RESTRICTION_CHINA_ACCESS,
                    explanation:
                        'This permission allows editing access to the News, Market Size Estimates,\n' +
                        'and Chrome Extension modules of a license. It specifically governs the ability\n' +
                        'to modify the state of these modules, provided the administrator has the necessary\n' +
                        'rights to create or edit the license.',
                },
                children: [],
            },
            {
                id: 'additional-admin-tools',
                expanded: true,
                data: {module: 'Additional Admin Tools', tree: null},
                children: [
                    {
                        id: 'manage-roles-permissions-access',
                        expanded: false,
                        data: {module: 'Manage Roles & Permissions', tree: ROLES_PERMISSIONS_MANAGEMENT_ACCESS},
                        children: [],
                    },
                    {
                        id: 'manage-entitlements-access',
                        expanded: false,
                        data: {module: 'Manage Entitlements', tree: MANAGE_ENTITLEMENTS_ACCESS},
                        children: [],
                    },
                    {
                        id: 'manage-entitlement-presets-access',
                        expanded: false,
                        data: {module: 'Manage Entitlement Presets', tree: MANAGE_ENTITLEMENT_PRESETS_ACCESS},
                        children: [],
                    },
                    {
                        id: 'login-link-generator-access',
                        expanded: false,
                        data: {module: 'Login Link Generator', tree: LOGIN_LINK_GENERATOR_ACCESS},
                        children: [],
                    },
                    {
                        id: 'live-agent-configurator-access',
                        expanded: false,
                        data: {module: 'Live Agent Configurator', tree: LIVE_AGENT_CONFIGURATOR_ACCESS},
                        children: [],
                    },
                    {
                        id: 'platform-alert-builder-access',
                        expanded: false,
                        data: {module: 'Platform Alert Builder', tree: PLATFORM_ALERT_BUILDER_ACCESS},
                        children: [],
                    },
                    {
                        id: 'internal-notification-builder-access',
                        expanded: false,
                        data: {module: 'Internal Notification Builder', tree: INTERNAL_NOTIFICATION_BUILDER_ACCESS},
                        children: [],
                    },
                    {
                        id: 'full-story-configurator-access',
                        expanded: false,
                        data: {module: 'FullStory Configurator', tree: FULL_STORY_CONFIGURATOR_ACCESS},
                        children: [],
                    },
                    {
                        id: 'sso-self-service-statistic-access',
                        expanded: false,
                        data: {module: 'SSO Self-Service Dashboard', tree: SSO_ACCOUNT_STATISTICS_ACCESS},
                        children: [],
                    },
                ],
            },
        ],
    },
    {
        id: 'pitchbook-editorial-settings',
        expanded: true,
        data: {module: 'PitchBook Editorial Settings', tree: null},
        children: [
            {
                id: 'market-map-verticals',
                expanded: false,
                data: {module: 'Create PitchBook Market Maps and Verticals', tree: CREATE_MARKET_MAP_VERTICALS_ACCESS},
                children: [],
            },
            {
                id: 'analyst-commentary-deals',
                expanded: false,
                data: {module: 'Analyst Commentary on Deals', tree: ANALYST_COMMENTARY_DEALS_ACCESS},
                children: [],
            },
        ],
    },
    {
        id: 'pitchbook-workspaces',
        expanded: true,
        data: {module: 'PitchBook Workspaces', tree: null},
        children: [
            {
                id: 'publish-pitchbook-workspaces',
                expanded: false,
                data: {module: 'Publish PitchBook Workspaces', tree: PUBLISH_WORKSPACES_ACCESS},
                children: [],
            },
        ],
    },
];
